import { render, staticRenderFns } from "./StockInventories.vue?vue&type=template&id=c6f81daa&"
import script from "./StockInventories.vue?vue&type=script&lang=js&"
export * from "./StockInventories.vue?vue&type=script&lang=js&"
import style0 from "./StockInventories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports